module.exports = __webpack_public_path__ + "img/navigation-0.15bdb34b.png";